import React from 'react'

import { Typography, Table } from 'antd'

const columns = ({ brokers }) => {
  return [
    {
      title: 'Charge',
      dataIndex: 'charge',
    },
  ].concat(
    brokers.map((broker, idx) => ({
      title: broker.attributes.name,
      dataIndex: idx,
    }))
  )
}

const keyNameMap = {
  plan_name: 'Plan Name',
  equity_delivery: 'Equity Delivery',
  equity_intraday: 'Equity Intraday',
  equity_futures: 'Equity Futures',
  equity_options: 'Equity Options',
  currency_futures: 'Currency Futures',
  currency_options: 'Currency Options',
  commodity: 'Commodity Options',
  mutual_fund: 'Mutual Fund',
}

const TitleComponent = (broker1Name, broker2Name) => {
  const { Title } = Typography

  return (
    <Title level={2}>
      {`${broker1Name} vs ${broker2Name} Brokerage Charges and Plans : `}
      {new Date().getFullYear()}
    </Title>
  )
}

export default function ConsolidatedCharges({ brokers }) {
  const charges = brokers.map((broker) => {
    const { consolidated_charges: consolidatedCharges } = broker.attributes
    const flagshipPlan = consolidatedCharges.find(
      (charge) => charge.flagship_plan === true
    )

    return flagshipPlan || consolidatedCharges[0]
  })

  const data = Object.keys(keyNameMap)
    .filter((k) => k !== '__typename')
    .map((k) => ({
      key: k,
      charge: keyNameMap[k] || k,
      ...charges.map((charge) => {
        if (!charge) return 'N/A'

        return charge[k] || 'N/A'
      }),
    }))

  return (
    <Table
      columns={columns({ brokers })}
      dataSource={data}
      bordered
      title={() =>
        TitleComponent(brokers[0].attributes.name, brokers[1].attributes.name)
      }
      pagination={false}
    />
  )
}
